import { ReactElement } from 'react';

import { FormProvider, useForm } from 'react-hook-form';
import initialValues from './form/initialValues';

import { IPatientCreateFormValues } from './types';
import validate from './form/validate';
import PatientEnrollmentOptionsProvider from '~/ui/components/providers/PatientEnrollmentProvider';
import AddPatientModal from './components/AddPatientModal';

interface IProps {
  onClose: () => void;
}

const AddPatient = ({ onClose }: IProps): ReactElement => {
  const form = useForm<IPatientCreateFormValues>({
    resolver: validate,
    defaultValues: initialValues,
  });

  return (
    <PatientEnrollmentOptionsProvider>
      <FormProvider {...form}>
        <AddPatientModal onClose={onClose} />
      </FormProvider>
    </PatientEnrollmentOptionsProvider>
  );
};

export default AddPatient;
